
namespace RioERP.Invoices {
    export class FinancialYearColumns {
        static columnsKey = 'Invoices.FinancialYear';
    }
}